function ModalWrapper()
{
    this.init.apply(this,Array.prototype.slice.call(arguments,0));
    return this;
}

var OpenedModals=0;

$(function(){
    setInterval(function(){
        
        if($(".modal.in").length && !$("body").hasClass("modal-open")) {
            $("body").addClass("modal-open");
        }else if(!$(".modal.in").length && $("body").hasClass("modal-open")){
            $("body").removeClass("modal-open");
        }
    },500);
});

$.extend(ModalWrapper.prototype, {
    modal:null,
    template:'<div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true"> ' +
    '<div class="modal-dialog modal-lg"> ' +
    '<div class="modal-content"> ' +
    '<div class="modal-header"> ' +
    '<h4 class="modal-title">Modal title</h4> ' +
    '</div> <div class="modal-body"> ' +
    '</div> ' +
    '<div class="modal-footer modal-footer-flex"> ' +
    '</div> ' +
    '</div> ' +
    '</div> ' +
    '</div>',
    options:{
        show:false,
        backdrop:'static',
        keyboard:false
    },
    modalOpts:{
        buttons:[
            {
                'id':'save',
                title:'Close',
                style:'btn-primary',
                cbs:[],
                event:'close'
            }
        ],
        autoShow:false,
        title:'',
        content:'Dummy string content'
    },
    contentClass:null,
    init: function (options) {
        if(options) {
            $.extend(this.modalOpts, options);
        }
        this.modal=$(this.template);
        this.modal.addClass("modal-ex-animate");
        $("body").append(this.modal);
        this.modal.hide();
        this.modal.modal(this.options);
        this.onShow(function(){
            OpenedModals++;
            console.log("after open",OpenedModals);
        });
        this.onHide(function(){
            OpenedModals--;
            if(OpenedModals) {
                if (!$("body").hasClass("modal-open")) {
                    $("body").addClass("modal-open");
                }
            }
            console.log("after close",OpenedModals);
        });
        this.render();
        if(this.modalOpts.autoShow)
            this.show();
    },
    setOption:function(key,val){
        this.modalOpts[key]=val;
        return this;
    },
    setOptions:function(options) {
        $.extend(this.modalOpts,options);
        return this;
    },
    show:function(){
        this.modal.attr("data-index",OpenedModals+1);
        $("[data-index="+OpenedModals+"]").addClass("do-deeper").css("z-index",(OpenedModals+1)*100);

        this.modal.modal('show');
        return this;
    },
    hide:function(){
        $("[data-index="+(OpenedModals - 1) +"]").removeClass("do-deeper");
        this.modal.modal('hide');
        return this;
    },
    hideDestroy:function(){
        $("[data-index="+(OpenedModals - 1) +"]").removeClass("do-deeper");
        this.modal.modal('hide');
        setTimeout(function(){
            //this.modal.modal('destroy');
            this.modal.remove();
        }.bind(this),500);
        return this;
    },
    onShow:function(cb) {

        this.modal.on("shown.bs.modal",cb);
        return this;
    },
    onHide:function(cb) {

        this.modal.on("hidden.bs.modal",cb);
        return this;
    },
    onBeforeShow:function(cb) {
        this.modal.on("show.bs.modal",cb);
        return this;
    },
    onBeforeHide:function(cb) {
        this.modal.on("hide.bs.modal",cb);
        return this;
    },
    render:function()
    {
        this.modal.find(".modal-footer button").remove();
        this.renderButtons();

        //change title
        if(this.modalOpts.title.length) {
            this.modal.find(".modal-title").show().text(this.modalOpts.title);
        }else {
            this.modal.find(".modal-title").hide();
        }

        if(this.contentClass===null)
        {
            if(typeof this.modalOpts.content==="string")
            {
                this.modal.find(".modal-body").html(this.modalOpts.content);
            }else{
                this.contentClass=new this.modalOpts.content(this);
                this.modal.find(".modal-body").append(this.contentClass.el);
            }
        }

    },
    renderButtons:function(){
        var footer=this.modal.find(".modal-footer");
        footer.html("");
        for(var i=0;i<this.modalOpts.buttons.length;i++)
        {
            var defaultButtonConfig={
                'id':'dummny',
                title:'no title',
                style:'btn-link',
                disabled:false,
                cbs:[],
                event:'close'
            };
            $.extend(defaultButtonConfig,this.modalOpts.buttons[i]);
            if(defaultButtonConfig.seperate) {
                footer.append("<span class=\"flex-seperate\"></span>");
            }else {
                var Button = $('<button type="button" class="btn waves-effect"></button>');
                Button[0].buttonConfig = defaultButtonConfig;
                Button.html(defaultButtonConfig.title);
                Button.on("click", this.onFooterButtonClick.bind(this));
                Button.addClass(defaultButtonConfig.style);
                Button.prop('disabled',defaultButtonConfig.disabled);
                footer.append(Button);
            }
        }
    },
    onFooterButtonClick:function(e)
    {
        e.preventDefault();
        var config=e.target.buttonConfig;
        var prevent=false;
        $.each(config.cbs,function(i,cb) {
            if(prevent)
                return;
            var res=cb(config.id);
            if(typeof res!=='undefined' && res===false)
                prevent=true;
        });
        if(prevent)
            return false;

        switch(config.event)
        {
            case 'close':
                this.hide();
                break;
        }
        return true;
    }
});
